import { getDataDailyPremiumAccess, saveDataDailyPremiumAccess,
  getCountryList, getDataAdsSettings, saveDataAdsSettings, getDataSkipQuotaSettings, saveDataSkipQuotaSettings,
  getDataAccountDeleteSurvey, saveAccountDeleteSurvey, addAdsFileTemp, getOnBoardingBannerList, deleteOnBoardingBanner,
  createOnBoardingBanner, getReferralBannerList, deleteReferralBanner, createReferralBanner, getReferralAboutList, setReferralAboutList
} from '@/services/appsetting';

const getters = {
  listCountry: state => state.listCountry,
};

const actions = {
  async requestDailyPremiumAccess({ commit, rootGetters }) {
    let res = {
      number_of_song: 0,
      threshold_number: 0,
      reset_time: '',
      status: 0,
    };
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getDataDailyPremiumAccess({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      res = response.data;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return res;
  },
  async requestSaveDailyPremiumAccess({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await saveDataDailyPremiumAccess(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: '' }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-save-premium-access' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListCountry({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getCountryList({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: '' }, { root: true });
      commit('SET_LIST_COUNTRY', response.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestAdsSettings({ commit, rootGetters }) {
    let res = {
      number_of_song: 0,
      file: null,
      files: [],
    };
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getDataAdsSettings({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      res = response.data;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return res;
  },
  async requestSaveAdsSettings({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await saveDataAdsSettings(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: '' }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-save-ads-settings' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestSkipQuotaSettings({ commit, rootGetters }) {
    let res = {
      threshold_number: 0,
      reset_time: '',
      status: 0,
    };
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getDataSkipQuotaSettings({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      res = response.data;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return res;
  },
  async requestSaveSkipQuotaSettings({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await saveDataSkipQuotaSettings(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: '' }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-save-skip-quota' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestAccountDeletionSurvey({ commit, rootGetters }) {
    let res = {
      title: '',
      description: '',
      options: [],
    };
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getDataAccountDeleteSurvey({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      res = response.data;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return res;
  },
  async requestSaveAccountDeletionSurvey({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await saveAccountDeleteSurvey(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: '' }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-save-account-del-survey' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestAddAdsFileTemp({ commit, dispatch, rootGetters }, { file, callback = (event) => {} }) {
    let response = null;
    try {
      response = await addAdsFileTemp(file, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, (event) => {
        callback(event);
      });
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'Success', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING_WITH_MESSAGE', { toggle: false, message: 'please wait...' }, { root: true });
    }
    return response;
  },
  async requestGetOnBoardingBanner({ commit, rootGetters }) {
    let res = [];
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getOnBoardingBannerList({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: '' }, { root: true });
      if (response.data) {
        res = response.data;
      }
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-save-account-del-survey' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return res;
  },
  async requestDeleteOnBoardingBanner({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await deleteOnBoardingBanner(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: '' }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-save-account-del-survey' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestCreateOnBoardingBanner({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await createOnBoardingBanner(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: '' }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-save-account-del-survey' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestGetReferralBanner({ commit, rootGetters }) {
    let res = [];
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getReferralBannerList({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: '' }, { root: true });
      if (response.data) {
        res = response.data;
      }
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-save-account-del-survey' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return res;
  },
  async requestDeleteReferralBanner({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await deleteReferralBanner(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: '' }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-save-account-del-survey' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestCreateReferralBanner({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await createReferralBanner(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: '' }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-save-account-del-survey' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestGetReferralAbout({ commit, rootGetters }) {
    let res = [];
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getReferralAboutList({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: '' }, { root: true });
      if (response.data) {
        res = response.data;
      }
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-save-account-del-survey' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return res;
  },
  async requestSetReferralAbout({ commit, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await setReferralAboutList({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: '' }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-save-account-del-survey' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
};

const mutations = {
  SET_LIST_COUNTRY(state, listCountry) {
    state.listCountry = listCountry;
  },
};

export default {
  namespaced: true,
  state: {
    listCountry: [],
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/AppSetting/index.js